import axios from 'axios';
import moment from 'moment';

const state = () => ({
  currentTrade: {},
  currentTradesub: {},
});

const getters = {};

const mutations = {};

const actions = {
  getTrades(_, userId) {
    console.log('getTrades start, userId: ', userId);
    return new Promise((resolve, reject) => {
      let promises = [];
      let trades = [];

      axios
        .get(`/Share/GetShareByTo/${encodeURIComponent(userId)}`)
        .then((resp) => {
          console.log('GetShareByTo resp: ', resp.data);
          resp.data.forEach((share) => {
            promises.push(axios.get(`/Trade/${share.orderId}`));
          });
          console.log('promises: ', promises);

          Promise.all(promises)
            .then((responses) => {
              responses.forEach((response) => {
                trades.push(response.data);
              });

              axios
                .get(`/Trade/ByCustId/${encodeURIComponent(userId)}`)
                .then((resp) => {
                  trades.push(...resp.data);
                  trades = trades.sort(
                    (a, b) => moment(b.trdate) - moment(a.trdate),
                  );
                  console.log('getTrades end, trades: ', trades);
                  resolve(trades);
                })
                .catch((err) => {
                  reject(err);
                });
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getTradeById(_, serno) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/Trade/${serno}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getTradesub(_, serno) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/Tradesub/${serno}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getHotel(_, hotelId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/Hotel/${hotelId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSharedTradeByFrom(_, userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/Share/GetShareByFrom/${encodeURIComponent(userId)}`)
        .then((res) => {
          let promises = [];
          let trades = [];

          res.data.forEach((share) => {
            promises.push(axios.get(`/Trade/${share.orderId}`));
          });

          Promise.all(promises)
            .then((responses) => {
              responses.forEach((response) => {
                trades.push(response.data);
                trades = trades
                  .map((t) => ({
                    ...t,
                    share: res.data.find((item) => item.orderId === t.serno),
                  }))
                  .sort((a, b) => moment(b.trdate) - moment(a.trdate));
                resolve(trades);
              });
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSharedTradeByTo(_, userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/Share/GetShareByTo/${encodeURIComponent(userId)}`)
        .then((res) => {
          let promises = [];
          let trades = [];

          res.data.forEach((share) => {
            promises.push(axios.get(`/Trade/${share.orderId}`));
          });

          Promise.all(promises)
            .then((responses) => {
              responses.forEach((response) => {
                trades.push(response.data);
                trades = trades.sort(
                  (a, b) => moment(b.trdate) - moment(a.trdate),
                );
                resolve(trades);
              });
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  importTrade(_, { orderId, fromId, toId }) {
    return new Promise((resolve, reject) => {
      axios
        .post('/Share', {
          orderId: orderId,
          fromId: fromId,
          toId: toId,
          status: 1,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
